import { BRAND_COLORS } from "../../constants";

/**
 * Design tokens for the audiogram editor shell. Keeps the editor visuals
 * (accent, surfaces, radii, canvas backdrop) consistent and avoids scattering
 * raw hex literals across the editor components.
 */
export const EDITOR_TOKENS = {
  accent: BRAND_COLORS.primary,
  accentDark: BRAND_COLORS.primaryDark,
  accentSoft: "rgba(37, 99, 235, 0.08)",
  accentSofter: "rgba(37, 99, 235, 0.04)",
  success: "#10b981",
  successDark: "#059669",
  danger: BRAND_COLORS.error,
  panelSurface: "#ffffff",
  controlRadius: "8px",
  frameRadius: "18px",
  // Subtle dotted backdrop behind the preview canvas.
  canvasDotColor: "rgba(15, 23, 42, 0.05)",
  canvasDotSize: "22px 22px",
} as const;

export const SECTION_LABEL_SX = {
  fontSize: "11px",
  fontWeight: 700,
  color: "text.secondary",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
} as const;
